import { RoomSnapshot } from '../room/types';
import type { PackQuestion } from '../pack/types';

interface AnswerRow { id: string; text: string; isCorrect?: boolean }

function correctAnswerText(
  q: PackQuestion | undefined,
  correctAnswerId: string | null,
): string {
  if (!q || !correctAnswerId) return correctAnswerId ?? '—';
  const answers = (q.answers as AnswerRow[] | undefined) ?? [];
  const hit = answers.find((a) => a.id === correctAnswerId);
  return hit?.text ?? correctAnswerId;
}

export function RevealScreen({
  snapshot,
  questionsById,
}: {
  snapshot: RoomSnapshot;
  questionsById: Map<string, PackQuestion>;
}) {
  const q = snapshot.currentQuestionId ? questionsById.get(snapshot.currentQuestionId) : undefined;
  const text = correctAnswerText(q, snapshot.correctAnswerId);

  return (
    <div className="app fade-in">
      <div style={{ fontSize: 28, color: 'var(--c-text-muted)' }}>
        Correct answer
      </div>
      <div className="question-tv" style={{ color: 'var(--c-success)' }}>
        {text}
      </div>

      <div className="spacer" />

      <div style={{ fontSize: 24, color: 'var(--c-text-muted)' }}>Scores</div>
      <div className="row">
        {[...snapshot.players]
          .sort((a, b) => b.score - a.score)
          .map((p, idx) => (
            <div className="player-card" key={p.playerId}>
              <div className="avatar" aria-hidden>{idx + 1}</div>
              <div>
                <div style={{ fontWeight: 600 }}>{p.displayName}</div>
              </div>
              <div className="score">{p.score}</div>
            </div>
          ))}
      </div>
    </div>
  );
}
